import React from 'react';

function Condicoes() {
  return (
    <>
      <h1>Produtos e serviços</h1>
      <p className="institucionalText">Se você deseja mais informações sobre os produtos e serviços que a Cooperativa Cocrafi possui, poderá utilizar este canal para esclarecimentos: <b>cocrafi@terra.com.br</b>.</p>
      <h1>Locais e horários de atendimento</h1>
      <ul className="details-list">
        <li>
          <p>
            <b>Endereço</b>: Núcleo D-67, 149 vila AFP - Charqueadas / RS.
          </p>
        </li>
        <li>
          <p>
            <b>Horário de atendimento</b>: De segunda-feira à sexta-feira, das 08:00h ás 18:00h (sem fechar ao meio-dia). 
          </p>
        </li>
        <li>
          <p>
            <b>Fale conosco</b>: (51) 99548-0598.
          </p>
        </li>
      </ul>
    </>
  )
}

export default Condicoes;